import { render, staticRenderFns } from "./ShiftRecord.vue?vue&type=template&id=1fb6576d&scoped=true"
import script from "./ShiftRecord.vue?vue&type=script&lang=js"
export * from "./ShiftRecord.vue?vue&type=script&lang=js"
import style0 from "./ShiftRecord.vue?vue&type=style&index=0&id=1fb6576d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb6576d",
  null
  
)

export default component.exports